import React, { useCallback } from 'react'
import { string, shape, object, func, bool } from 'prop-types'
import { Form } from 'antd'
import { validateCNPJ } from '../../../utils'
import MaskedInput from 'antd-mask-input'
import InfoField from '~/components/infoField'
import { useFocusCallback } from 'utils/fieldHooks'

const CnpjField = ({
	pageFieldsData,
	className,
	onChange,
	onFocus,
	first,
	inputValue,
	disabled,
	visible,
}) => {
	const { label, variable, type, id, info, list, optional } = pageFieldsData
	const isObj = typeof variable === 'object'
	const varname = isObj ? variable.name : variable
	const name = id !== undefined ? `${varname}_${id}` : varname

	const changeCallback = useCallback(
		(e) => (onChange ? onChange(e.target.value) : undefined),
		[onChange]
	)

	const focusCallback = useFocusCallback(onFocus, pageFieldsData)

	return (
		<Form.Item
			key={name}
			name={list !== undefined ? [list, name] : name}
			label={
				<InfoField
					label={
						<span>
							{label}
							{!optional && <span style={{ color: 'red' }}> *</span>}
						</span>
					}
					info={info}
				/>
			}
			type={type}
			className={className}
			hasFeedback
			rules={
				visible && [
					() => ({
						validator(rule, value) {
							if (!value) {
								if (optional) return Promise.resolve()
								else return Promise.reject('Este campo é obrigatório.')
							} else {
								if (validateCNPJ(value)) return Promise.resolve()
								else return Promise.reject('CNPJ não é válido.')
							}
						},
					}),
				]
			}
			colon={false}
			initialValue={!inputValue ? '' : inputValue}>
			<MaskedInput
				onChange={changeCallback}
				onFocus={focusCallback}
				autoFocus={first}
				mask="00.000.000/0000-00"
				placeholder=""
				disabled={disabled}
			/>
		</Form.Item>
	)
}

CnpjField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: object.isRequired,
		type: string.isRequired,
		info: string,
	}).isRequired,
	className: string,
	onChange: func,
	onFocus: func,
	first: bool,
	inputValue: string,
	disabled: bool,
	visible: bool,
}

CnpjField.defaultProps = {
	className: {},
	visible: true,
}

export default CnpjField
